<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" max-width=568 :fullscreen="$vuetify.breakpoint.xsOnly" persistent fluid scrollable content-class="round-2xl")
  v-card
    v-card-title.px-4
      v-row(no-gutters align="center")
        v-col(offset="1" cols="10" align="center")
          .text-lg.font-bold.text-center Create new segment
        v-col(cols="1" align="right")
          v-btn(icon @click="closeDialog")
            v-icon mdi-close
    v-divider

    v-card-text.pa-6
      v-form(ref="form")
        div.text-sm.font-semibold.neutral700--text Segment name
        v-text-field.text-sm.mt-2.round-xl(v-model="name" placeholder="Enter segment name" outlined dense height="48" :rules="rules.not_empty" hide-details="auto")
        div.text-sm.font-semibold.neutral700--text.mt-4 Segment description
        v-textarea.text-sm.mt-2.round-xl(v-model="description" placeholder="Enter segment description" outlined dense rows="3" hide-details="auto")
        div.text-sm.font-semibold.neutral700--text.mt-4 Choose type of segment
        v-radio-group.text-md.mt-2(v-model="dynamic" hide-details :rules="rules.not_empty")
          v-radio(:value="false" color="neutral700" )
            template(#label)
              div.text-sm.font-medium.neutral700--text Static segment
          v-radio(:value="true" color="basic700" )
            template(#label)
              div.text-sm.font-medium.neutral700--text Dynamic segment
    v-divider

    v-card-actions.py-4.px-6
      v-spacer
      y-button.mr-4(:label="$t('cancel')" underline color="neutral700" size="sm" button-class="px-0" @click="closeDialog")
      y-button(label="Create new" text-color="neutral100" color="neutral700" size="sm" dark :loading="isLoading" @click="saveData")
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import SegmentsDropdown from '@/components/clinic/segments/SegmentsDropdown.vue'

export default {
  components: {
    SegmentsDropdown,
  },
  props: ['open'],
  data: () => ({
    isLoading: false,
    name: null,
    description: null,
    dynamic: false,
    rules: {
      not_empty: [v => (v != null && v.toString().trim().length) || 'This field is required'],
      has_quantity: [v => !!v || 'This field is required', v => v != 0 || 'This field is required'],
      has_price: [(v) => !!v || 'This field is required', (v) => v >= 0 || `Amount should be more than ${this.$currency.symbol} 0`],
      not_empty_select: [v => !!v || 'This field is required']
    },
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
    showDialog: {
      get () {
        return this.open
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    },
  },
  methods: {
    ...mapActions(['showMessage']),
    saveData () {
      if (!this.$refs.form.validate()) {
        return
      }
      this.isLoading = true
      let data = {
        title: this.name,
        description: this.description,
        dynamic: this.dynamic
      }
      this.$axios.post(`/connect/${this.company.slug}/groups`, data)
        .then(() => {
          this.closeDialog()
          this.$emit('updated')
        })
        .catch(err => {
          let message = this.$t('error_message.unable_to_complete_request')
          if (err.response.data) {
            if (err.response.data.detail) {
              message = err.response.data.detail
            } else {
              let data = JSON.stringify(err.response.data).replace(/[^\w.\s:]/g, '').replace(/[.:]/g, match => match + ' ')
              if (data) { message = data }
            }
          }
          this.showMessage(['error', message])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    closeDialog () {
      this.showDialog = false
    }
  }
}
</script>